import { ApplicationService } from 'src/app/shared/services/application.service';
import { Component, OnInit, Input, forwardRef, SimpleChanges, AfterViewInit, OnChanges } from '@angular/core';
import { ParentDetails, ParentDetailsErrors, ParentDetailsConfig } from 'src/app/application/models/parent-guardian-details';
import { FormGroup, FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Country, LookupData } from 'src/app/shared/models/lookup-data.model';
import { AustralianStates } from 'src/app/application/shared/address/address.model';
import { UUID} from 'angular2-uuid';
import { slideInOut } from 'src/app/application/animations/slideInOut';
import { AddressService } from '../../../../shared/services/address.service';
@Component({
  selector: 'online-app-parent-legalcustodian-details',
  templateUrl: './parent-legalcustodian-details.component.html',
  styleUrls: ['./parent-legalcustodian-details.component.scss'],
  animations: [slideInOut],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ParentLegalcustodianDetailsComponent),
    multi: true
  }]
})
export class ParentLegalcustodianDetailsComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() data: ParentDetails;
  @Input() errors: ParentDetailsErrors;
  @Input() config: ParentDetailsConfig;
  parentDetailsFormGroup: FormGroup;

  gender: string = '';
  countries: Country[];
  isAustralianAddress: boolean = false;
  applicationId: number;
  australianStates: any[];
  isRefusedAusVisaBefore: boolean;
  isSameAddress: boolean = false;

  selectedCountry: LookupData;
  selectedAustralianState: LookupData;

  datepickerLoaded = false;
  datepickerId = '';

  private _value: ParentDetails = {
    SchoolProgramType: undefined,
    DateOfBirth: undefined,
    Gender: undefined,
    CountryOfBirthId: undefined,
    CountryOfNationalityId: undefined,
    PassportNumber: undefined,
    EmailAddress: undefined,
    Note: undefined,
    IsRefusedAusVisaBefore: undefined,
    VisaRefusalDetails: undefined,
    
    MobileCountryCode: undefined,
    MobilePhoneNumber: undefined,
    HomeCountryCode: undefined,
    HomePhoneNumber: undefined,
    
    IsAustralianAddress: undefined,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined,

    IsSameAddress: undefined
  };

  constructor(private formBuilder: FormBuilder,
    private addressService: AddressService,
    private activatedRoute: ActivatedRoute,) {
      this.activatedRoute.parent.parent.params.subscribe(params =>{
        this.applicationId = +params['id'];
      });

      this.selectedAustralianState = this.getDefaultAustralianState();

      this.datepickerId = UUID.UUID();
      this.datepickerLoaded = true;

     }

     ngAfterViewInit() {

      // this.configureJQuery();
     }

  ngOnInit() {
    const countries = this.activatedRoute.snapshot.data['countries'];
    this.countries = [this.getDefaultCountry(), ...countries];

    this.parentDetailsFormGroup = this.formBuilder.group({
    });

    this.australianStates = [this.getDefaultAustralianState(), ...AustralianStates ] ;

    // this.configureJQuery();    
    this.isSameAddress = this.config.isSameAddress;
    this._updateValue(this.config.isSameAddress, 'IsSameAddress');
    // console.log('this.config: ', this.config);
    // console.log('this.isSameAddress: ', this.isSameAddress);
    // console.log('this.value.IsSameAddress: ', this.value.IsSameAddress);
    this.isAustralianAddress = this.data.IsAustralianAddress;
    if (this.data.IsAustralianAddress) {
      this.widget = this.addressService.loadAddressWidget('AuAddressLine1', this, this.setAddressPart);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.value = changes.data.currentValue;
    }
  }


  private _onChange = (_: any) => {};
  private _onTouched = (_: any) => {};

  set value(value: ParentDetails) {
    this._value = value;
    this._onChange(this._value);
  }

  get value() {
    return this._value;
  }

  writeValue(value: ParentDetails): void {
    if (value && value !== null) {
      this._value = value;
    }
  }
  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: (_: any) => void): void {
    this._onTouched = fn;
  }

  private _updateValue(value: any, field: string) {
    const newValue = this._value;
    newValue[field] = value;
    this.value = newValue;
    // console.log('updated value');
    // console.log(newValue);
  }
  updateIsRefusedAusVisaBefore(isRefusedAusVisaBefore: boolean) {

    this.isRefusedAusVisaBefore = isRefusedAusVisaBefore;
    this._updateValue(isRefusedAusVisaBefore, 'IsRefusedAusVisaBefore');
    this.errors.IsRefusedAusVisaBefore = '';
  }
  visaRefusalDetailsUpdate(event: any) {
    this._updateValue(event.target.value, "VisaRefusalDetails");

    var noOfWords = event && event.target && event.target.value ? event.target.value.match(/\S+/g).length : 0;

    if (noOfWords > 50) {
      this.errors.VisaRefusalDetails = "Can not exceed 50 words";
    } else {
      this.errors.VisaRefusalDetails = '';
    }

  }
  updateGenderValue(genderValue: string) {
    if (genderValue === 'male') {
      this.gender = 'M';
    } else if (genderValue === 'female') {
      this.gender = 'F';
    } else {
      this.gender = '';
    }
    this._updateValue(this.gender, 'Gender');
    this.errors.Gender = '';
  }
  countryOfBirthUpdate(code: any) {
    this._updateValue(code, 'CountryOfBirthId');
    this.errors.CountryOfBirthId = '';
  }
  nationalityUpdate(code: any) {
    this._updateValue(code, 'CountryOfNationalityId');
    this.errors.CountryOfNationalityId = '';
  }
  passportNumberUpdate(event: any) {
    this._updateValue(event.target.value, 'PassportNumber');
    this.errors.PassportNumber = '';
  }
  emailAddressUpdate(event: any) {
    this._updateValue(event.target.value, 'EmailAddress');
    this.errors.EmailAddress = '';
  }
  dateOfBirthUpdateValue(value: any) {
    this._updateValue(value, 'DateOfBirth');
    this.errors.DateOfBirth = '';
  }
  mobileCountryCodeUpdate(event: any) {
    this._updateValue(event.target.value, 'MobileCountryCode');
    this.errors.MobileCountryCode = '';
  }
  mobilePhoneNumberUpdate(event: any) {
    this._updateValue(event.target.value, 'MobilePhoneNumber');
    this.errors.MobilePhoneNumber = '';
  }
  homeCountryCodeUpdate(event: any) {
    this._updateValue(event.target.value, 'HomeCountryCode');
    this.errors.HomeCountryCode = '';
  }
  homePhoneNumberUpdate(event: any) {
    this._updateValue(event.target.value, 'HomePhoneNumber');
    this.errors.HomePhoneNumber = '';
  }
  private widget = null;
  countryUpdate(countryId: any) {
    this._updateValue(countryId, 'CountryId');
    const australia  = this.countries.filter( c => c.Code === 'AU') as Country[];
    if(australia){
      this.isAustralianAddress = countryId.toLowerCase() === australia[0].Id.toLowerCase();
    }
    this._updateValue(this.isAustralianAddress, 'IsAustralianAddress');
    this.errors.CountryId = '';
    if (this.isAustralianAddress) {
      this.addressService.loadAddressWidget('AuAddressLine1', this, this.setAddressPart);
    }
  }
  line1Update(event: any) {
    this._updateValue(event.target.value, 'AddressLine1');
    this.errors.AddressLine1 = '';
  }
  line2Update(event: any) {
    this._updateValue(event.target.value, 'AddressLine2');
    this.errors.AddressLine2 = '';
  }
  suburbUpdate(event: any) {
    this._updateValue(event.target.value, 'SuburbTownCity');
    this.errors.SuburbTownCity = '';
  }
  stateInputUpdate(event: any) {
    this._updateValue(event.target.value, 'StateProvinceRegion');
    this.errors.StateProvinceRegion = '';
  }
  stateUpdate(code: any) {
    this._updateValue(code, 'StateProvinceRegion');
    this.errors.StateProvinceRegion = '';
  }
  postcodeUpdate(event: any) {
    this._updateValue(event.target.value, 'Postcode');
    this.errors.Postcode = '';
  }

  isSameAddressClicked(event) {
    this.value.IsSameAddress = event.checked;
    const isSameAddressNewValue = this.value.IsSameAddress;
    this._updateValue(isSameAddressNewValue, 'IsSameAddress');
    this.isSameAddress = isSameAddressNewValue
  }

  getDefaultCountry(): Country {
    return {
      Id: '',
      Code: '',
      Description: 'Please select Country',
      Status: '',
      IsAgentMandatory: false,
      CanStudyAbroad: false,
      PhoneCode: 0,
      IsDeleted: false,
    };
  }
  getDefaultAustralianState(): LookupData  {
    return {
      Code: '',
      Description: 'Please select',
    };
  }

  getDateOfBirthValue(dob: any) {
    let dateOfBirthValue = null;
    if (!dob) {
      dateOfBirthValue = '';
    } else {
      const dateOfBirth = new Date(dob);
      dateOfBirthValue = dateOfBirth;
    }

    return dateOfBirthValue;
  }
  
  loadGender(gender: string) {
    if (gender === 'M') {
      this.updateGenderValue('male');
    } else if (gender === 'F') {
      this.updateGenderValue('female');
    } else {
      this.updateGenderValue('');
    }
  }

  dummyClousure(thisObj: any, fnToBeCalled: any ) {
    return function(fnArg: any) {
      return fnToBeCalled.call(thisObj, fnArg);
    };
  }


  updateDateOfBirth(date: any) {
    this.dateOfBirthUpdateValue(date); 
  }

  countryCodeDescription(country: Country) {
    const selectedCountry = this.countries.find(c => c.Code === country.Code);
    if (selectedCountry && selectedCountry.Code.length > 0) {
      return `${selectedCountry.Description} (+${selectedCountry.PhoneCode})`;
    }
    return 'Country code';
  }
  getPostcodeText(): string {
    return this.isAustralianAddress ? 'Postcode' : 'Postcode/Zipcode';
  }

  /* For accessibility, keyboard only design, use tab to show borders but showing no border by clicking on mouse */
  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }
  private setAddressPart(container, line1Ctl,  line1: string, suburb: string, state: string, postcode: string) {
    setTimeout(() => {
            container._value.AddressLine1 = line1;
            container._updateValue(line1, 'AddressLine1');
            line1Ctl.blur();
          }, 10);
    container._value.AddressLine1 = line1;
    container._value.AddressLine2 = '';
    container._value.SuburbTownCity = suburb;
    container._value.StateProvinceRegion = state;
    container._value.Postcode = postcode;
    if (container.errors) {
      container.errors.AddressLine1 = '';
      container.errors.AddressLine2 = '';
      container.errors.SuburbTownCity = '';
      container.errors.StateProvinceRegion = '';
      container.errors.Postcode = '';
    }
  } 
}
